<template>
  <client-layout>
    <v-row no-gutters align="center" class="content-header">
      <span class="font-weight-bold">Équipments</span>
      <v-spacer></v-spacer>
      <!-- <v-btn dark color="primary" elevation="0" @click="isNewUserDialogOpened = true">
        <v-icon left>add</v-icon>
        Nouvel utilisateur
      </v-btn> -->
    </v-row>
    <n-card class="pa-6 font-weight-medium">
      Liste des équipements pour ce client bientôt ici...
    </n-card>
  </client-layout>
</template>

<script>
// import { mapState } from 'vuex';
import ClientLayout from '@/views/settings/clients/ClientLayout.vue';
// import UsersList from '@/views/settings/UsersList.vue';

export default {
  data: () => ({
  }),
  computed: {
    // ...mapState(`model/client`, {
    //   client: `currentAdminClient`,
    // }),
  },
  components: {
    ClientLayout,
    // UsersList,
  },
};
</script>
